import { css } from '@/styled-system/css';

export const modalHeaderStyles = css.raw({
  'flexGrow': 0,
  'flexShrink': 0,
  'flexBasis': 'auto',
  'paddingBlock': 'default',
  'paddingInlineStart': 'layout.tight',
  'paddingInlineEnd': 'layout.looser',

  '& > .c11n_heading': {
    color: 'text.neutral',
    textStyle: 'heading-xs',
  },
});
